import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaCheckCircle, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import buildLink from "../../../urls";
import axios from "axios";
import MessageAlert from "../../../components/messageAlert";
import { PlaySounds } from "../../../functions/playSounds";
import hocStarredPage from "../../../components/hocStarredPage";
import { getDetectedOrderType } from "../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../axiosServer";

const OrderProductv2 = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const orderId = useRef(null);
  const [loading, setLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useState("normal");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  var host = window.location.host;

  const searchOrder = async (e) => {
    e.preventDefault();

    let detectedOrderType = orderStatus;
 
    if (host == "pda.ishtari.com" || host.startsWith("localhost") || host == "pda.ishtari.com.gh") {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(orderId.current.value);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setOrderStatus(type);
    }

    let order_type;

    if (host == "pda.ishtari.com" || host.startsWith("localhost") || host == "pda.ishtari.com.gh") {
      order_type = detectedOrderType;
    } else {
      order_type = orderStatus;
    }

    setLoading(true);

    try {
      var url = "";
      if (order_type == "normal") {
        url =
          buildLink("productsFullVersion") +
          `&order_id=${orderId.current.value}`;
      } else if (order_type == "return") {
        url =
          buildLink("returnProductsFullVersion") +
          `&return_order_id=${orderId.current.value}`;
      }

      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          history("orderproductlistv2", {
            state: {
              products: response.data.data.products,
              logistic: response.data.data.logistic_id,
              orederStatus: order_type,
              order_id: response.data.data.order_id,
            },
          });
        }
      });
      setLoading(false);
    } catch (e) {
      playErrorSound();
      setLoading(false);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const history = useNavigate();
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];

  useEffect(() => {
    orderId.current.focus();
  }, []);

  const handleTrashClick = () => {
    orderId.current.value = "";
    orderId.current.focus();
  };

  return (
    <>
      <div className=" h-full bg-white ">
        {/* header */}
        <div className=" z-30 mb-5 sticky top-0 flex flex-col ">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Prepare Order</h2>
            </div>
          </div>
        </div>

        <div className=" container">
          <form
            onSubmit={(e) => searchOrder(e)}
            className=" flex flex-col gap-5 justify-center"
          >
            <div className="relative flex-1">
              <div className="mb-1">Order ID</div>
              <input
                ref={orderId}
                type="text"
                className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                placeholder="Order Id"
              />
              <div>
                <FaTrash
                  onClick={() => handleTrashClick()}
                  className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                />
              </div>
            </div>
            {host !== "pda.ishtari.com" && !host.startsWith("localhost") && host !== "pda.ishtari.com.gh" && (
              <div className=" py-3">
                <div className="mb-1">Order Type</div>
                <Select
                  placeholder="Order Type"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "7px",
                      borderColor: state.isFocused ? "grey" : "grey",
                      outline: "red",
                      padding: "8px 5px",
                    }),
                  }}
                  onChange={(e) => setOrderStatus(e.value)}
                  options={options}
                />
              </div>
            )}

            <button
              type="submit"
              onClick={(e) => {}}
              className=" bg-dbase  px-3 py-3 text-white rounded-sm mt-3"
            >
              {" "}
              {loading ? "Loading..." : "Confirm"}
            </button>
          </form>
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(OrderProductv2);
